/** Ítems para inspección visual: latonería, pintura, vidrios. Ids en camelCase. */

export const LATORERIA_ITEMS = [
    { id: 'capo', label: 'CAPO' },
    { id: 'capota', label: 'CAPOTA' },
    { id: 'guardafangoDelanteroDerecho', label: 'GUARDAFANGO DELANTERO DERECHO' },
    { id: 'guardafangoDelanteroIzquierdo', label: 'GUARDAFANGO DELANTERO IZQUIERDO' },
    { id: 'guardafangoPosteriorDerecho', label: 'GUARDAFANGO POSTERIOR DERECHO' },
    { id: 'guardafangoPosteriorIzquierdo', label: 'GUARDAFANGO POSTERIOR IZQUIERDO' },
    { id: 'parachoqueDelantero', label: 'PARACHOQUE DELANTERO' },
    { id: 'parachoquePosterior', label: 'PARACHOQUE POSTERIOR' },
    { id: 'puertaDelanteraDerecha', label: 'PUERTA DELANTERA DERECHA' },
    { id: 'puertaPosteriorDerecha', label: 'PUERTA POSTERIOR DERECHA' },
    { id: 'puertaDelanteraIzquierda', label: 'PUERTA DELANTERA IZQUIERDA' },
    { id: 'puertaPosteriorIzquierda', label: 'PUERTA POSTERIOR IZQUIERDA' },
    { id: 'costadoIzquierdo', label: 'COSTADO IZQUIERDO' },
    { id: 'costadoDerecho', label: 'COSTADO DERECHO' },
    { id: 'baulTapaCompuertaPosterior', label: 'BAUL / TAPA / COMPUERTA POSTERIOR' },
    { id: 'travesanoInferiorDerecho', label: 'TRAVESAÑO INFERIOR DERECHO' },
    { id: 'travesanoInferiorIzquierdo', label: 'TRAVESAÑO INFERIOR IZQUIERDO' },
    { id: 'platonBalde', label: 'PLATÓN' }
];

export const PINTURA_ITEMS = [
    { id: 'capaDePintura', label: 'CAPA DE PINTURA' }
];

export const VIDRIOS_ITEMS = [
    { id: 'vidrioDerechoDel', label: 'VIDRIO DERECHO DEL.' },
    { id: 'vidrioIzquierdoDel', label: 'VIDRIO IZQUIERDO DEL.' },
    { id: 'vidrioDerechoPost', label: 'VIDRIO DERECHO POST.' },
    { id: 'vidrioIzquierdoPost', label: 'VIDRIO IZQUIERDO POST.' },
    { id: 'panoramico', label: 'PANORÁMICO' },
    { id: 'panoramicoPost', label: 'PANORÁMICO POST.' },
    { id: 'espejosRetrovisores', label: 'ESPEJOS RETROVISORES' },
    { id: 'persianaDelantera', label: 'PERSIANA DELANTERA' }
];

const VALID_VALUES = ['Bueno', 'Regular', 'Malo', 'N/A'];

/**
 * Comprueba si en visualInspection todos los ítems de latonería, pintura y vidrios tienen un valor válido.
 * @param {Object} visualInspection - inspection.visualInspection
 * @returns {boolean}
 */
export function isVisualInspectionComplete(visualInspection) {
    if (!visualInspection || typeof visualInspection !== 'object') return false;
    const checkCategory = (items, data) => items.every(item => data && VALID_VALUES.includes(data[item.id]));
    return (
        checkCategory(LATORERIA_ITEMS, visualInspection.latoneria) &&
        checkCategory(PINTURA_ITEMS, visualInspection.pintura) &&
        checkCategory(VIDRIOS_ITEMS, visualInspection.vidrios)
    );
}
